import { render } from "./articleCollect.vue?vue&type=template&id=df2da5ac&scoped=true"
import script from "./articleCollect.vue?vue&type=script&lang=js"
export * from "./articleCollect.vue?vue&type=script&lang=js"

import "./articleCollect.vue?vue&type=style&index=0&id=df2da5ac&lang=scss&scoped=true"
import "./articleCollect.vue?vue&type=style&index=1&id=df2da5ac&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2da5ac"]])

export default __exports__